import { apolloClient } from '@/apollo-provider'
import { AxiosInstance } from 'axios'
import Vue from 'vue'
import { Module } from 'vuex'

import { AllCasesQuery, AllCasesQueryVariables } from '@/graphql-schema'
import { AllCases } from '@/queries/cases.graphql'
import { Diff, NotNull, Unpacked } from '@/utils'

export type Case = NotNull<Unpacked<NotNull<AllCasesQuery['cases']>['nodes']>>

export interface ModuleState {
  cases: { [key: string]: Case }
  selectCaseId: string | null
}

const moduleCases: Module<ModuleState, any> = {
  state: {
    cases: {},
    selectCaseId: window.sessionStorage.getItem('currentCaseId'),
  },
  actions: {
    USER_LOGGED_OUT: {
      root: true,
      handler({ commit }) {
        commit({ type: 'resetState' })
      },
    },
    USER_SIGNED_IN: {
      root: true,
      handler({ dispatch }) {
        return dispatch({ type: 'queryCases' })
      },
    },
    queryCases({ commit, rootGetters }) {
      return apolloClient
        .query<AllCasesQuery, AllCasesQueryVariables>({
          fetchPolicy: 'no-cache',
          query: AllCases,
        })
        .then(query => {
          let cases = query.data.cases!.nodes
          commit({ type: 'setCases', cases: cases })
          if (cases.length > 0) {
            commit({ type: 'setCurrentCaseId', caseId: cases[0].id })
          }
        })
    },
    setCurrentCaseId({ commit }, { caseId }) {
      commit({ type: 'setCurrentCaseId', caseId })
    },
  },
  mutations: {
    setCurrentCaseId(state, { caseId }) {
      state.selectCaseId = caseId
      window.sessionStorage.setItem('currentCaseId', caseId)
    },
    setCases(state, { cases }: { cases: Case[] }) {
      cases.forEach(c => Vue.set(state.cases, c.id, c))
      return cases
    },
    resetState(state) {
      state.cases = {}
      state.selectCaseId = null
      window.sessionStorage.removeItem('currentCaseId')
    },
  },
  getters: {
    currentCaseId(state, getters) {
      return getters.currentCase && getters.currentCase.id
    },
    availableCases(state) {
      return state.cases
    },
    numberOfCases(state): number {
      return Object.keys(state.cases).length
    },
    currentCase(state) {
      if (state.selectCaseId) {
        return state.cases[state.selectCaseId]
      }
      const keys = Object.keys(state.cases).sort()
      if (keys.length === 0) {
        return null
      }
      return state.cases[keys[0]]
    },
    currentInvolvement(state, getters) {
      if (!getters.currentCase) {
        return {}
      } else {
        return getters.currentCase.me
      }
    },
    currentCaseMembers(state, getters) {
      if (!getters.currentCase) {
        return {}
      } else {
        return getters.currentCase.others.nodes
      }
    },
  },
}

export default moduleCases
